import { Pipe, PipeTransform } from '@angular/core';

interface StatusIcon {
  token: string;
  priority: number;
}

interface VehicleStatus {
  statusicons?: {
    icon?: StatusIcon[];
  };
}

@Pipe({
  name: 'statusIcon',
})
export class StatusIconPipe implements PipeTransform {
  transform(
    value: VehicleStatus | VehicleStatus[],
    checkAllVehicles: boolean = false
  ): string | null {
    if (!Array.isArray(value)) {
      return this.getHighestPriorityIcon(value);
    }

    if (checkAllVehicles) {
      const statusTokens = value.map((vehicle) =>
        this.getHighestPriorityIcon(vehicle)
      );

      const firstStatus = statusTokens[0];
      const allSameStatus = statusTokens.every(
        (status) => status === firstStatus
      );

      return allSameStatus ? firstStatus : null;
    } else {
      return this.getHighestPriorityIcon(value[0]);
    }
  }
  private getHighestPriorityIcon(vehicle: VehicleStatus): string | null {
    if (!vehicle) {
      return null;
    }

    if (!vehicle.statusicons) {
      return null;
    }

    if (!vehicle.statusicons.icon || vehicle.statusicons.icon.length === 0) {
      return null;
    }

    // Sort icons by priority (lower number means higher priority)
    const sortedIcons = [...vehicle.statusicons.icon].sort(
      (a, b) => a.priority - b.priority
    );
    return sortedIcons[0].token || null;
  }
}
